import { render, staticRenderFns } from "./AddAll.vue?vue&type=template&id=3fb36f9f&scoped=true&"
import script from "./AddAll.vue?vue&type=script&lang=js&"
export * from "./AddAll.vue?vue&type=script&lang=js&"
import style0 from "./AddAll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb36f9f",
  null
  
)

export default component.exports